export enum VerticalMenuTabsEnum {
    USERS = 'users',
    CREDIT_LIMITS = 'creditLimits',
    PIPELINE_GROWTH_DIGEST = 'pipelineGrowthDigest',
    SALESFORCE_SETTINGS = 'salesforceSettings',
    DYNAMICS_365_SETTINGS = 'dynamic365Settings',
    INTENT = 'intent',
    EXPORT_APPS ='exportApps',
    CREATE_APPS ='createApp'
}